import { useRef } from 'react';
import { useMathJax } from '../../../hooks/useMathJax';
import { processText, svgToDataUrl } from '../../../utils/learnUtils';

/**
 * Renders an EDCOMP_ATTRIBUTION content item.
 * Right-justified box occupying data.width of the canvas, with image and caption centred.
 * @param {{ item: object }} props
 */
export default function AttributionComp({ item }) {
  const { image, text, width = '40%' } = item.data ?? {};
  const textRef = useRef(null);
  useMathJax(textRef, [text]);

  return (
    <div
      className="ct__attribution"
      style={{ width }}
    >
      {image && (
        <img
          src={svgToDataUrl(image)}
          alt=""
          className="ct__attribution-img"
        />
      )}
      {text && (
        <p
          ref={textRef}
          className="ct__attribution-text"
          dangerouslySetInnerHTML={{ __html: processText(text) }}
        />
      )}
    </div>
  );
}
